module.exports = "# よくある質問\n\n[[toc]]\n\n-------------------\n\n&nbsp;\n## ローカル開発でApiFrontは使えますか？\n\nQ. コンテナイメージでの提供はしていないので、ローカル環境でApiFrontを動作させることはできません。\n"